import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I am Vansh Varshney Final Year Undergrad, I am an enthusiastic engineer, I am currently pursuing Bachelor of Engineering (B.tech) in Computer Science and Engineering (CSE) From Galgotias University, Greater Noida (India).`}</p>
    <p>{`I am a Full Stack Developer and integration with intuitive problem-solving skills. Looking to start the career as an entry-level software engineer (SDE) role with a reputed firm driven by technology.`}</p>
    <p>{`Checkout My `}<a href="https://vanshresume.netlify.app/" target="_blank">{`RESUME`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      